<template>
  <div v-if="mounted && showHost" class="campanha-interna-popup-host">
    <div
      id="campanhaInternaPopupModal"
      class="modal fade campanha-interna-popup-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="true"
    >
      <div class="modal-dialog modal-dialog-centered" :class="modalDialogClass" role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            :class="{ 'justify-content-end border-bottom-0 pb-2': !showModalTitle }"
          >
            <h5 v-if="showModalTitle" class="modal-title mb-0 pr-2">
              {{ payload && payload.nome ? payload.nome : 'Campanha' }}
            </h5>
            <button type="button" class="close" aria-label="Fechar" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <CampanhaInternaPopupBlocks
              v-if="payload && payload.conteudo"
              :conteudo="payload.conteudo"
              :campanha-id="campanhaId"
              @close="closeModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CampanhaInternaPopupBlocks from './CampanhaInternaPopupBlocks.vue';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

function csrf() {
  const m = document.querySelector('meta[name="csrf-token"]');
  return m ? m.getAttribute('content') : '';
}

export default {
  name: 'CampanhaInternaPopupHost',
  components: { CampanhaInternaPopupBlocks },
  data() {
    return {
      mounted: false,
      payload: null,
      campanhaId: null,
    };
  },
  computed: {
    showHost() {
      if (String(window.super) === '1' && !window.campanhaInternaShowPopupSuper) {
        return false;
      }
      return true;
    },
    showModalTitle() {
      if (!this.payload || !this.payload.conteudo) return true;
      return this.payload.conteudo.exibir_nome_no_titulo !== false;
    },
    modalDialogClass() {
      const w = this.payload && this.payload.conteudo && this.payload.conteudo.modal_largura;
      if (w === 'auto') return 'campanha-interna-popup-modal__dialog--fit';
      if (w === 'xl') return 'modal-xl';
      if (w === 'lg') return 'modal-lg';
      return 'modal-lg';
    },
  },
  mounted() {
    this.mounted = true;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf();
    const run = () => this.fetchPopup();
    if (document.readyState === 'complete') {
      setTimeout(run, 0);
    } else {
      window.addEventListener('load', run);
    }
  },
  methods: {
    async fetchPopup() {
      if (!this.showHost) return;
      const routeName =
        (window.campanhaInternaContext && window.campanhaInternaContext.route) || '';
      try {
        const base = (window.baseUrl || '').replace(/\/$/, '');
        const url = `${base}/painel/campanha-internas/popup`;
        const { data, status } = await axios.get(url, {
          params: { route: routeName },
          headers: jsonHeaders,
          validateStatus: (s) => s === 200 || s === 204,
        });
        if (status === 204 || !data) return;
        this.payload = data;
        this.campanhaId = data.id;
        this.$nextTick(() => this.openModal());
      } catch (e) {
        if (e.response && e.response.status === 204) return;
        console.error(e);
      }
    },
    openModal() {
      const dom = document.getElementById('campanhaInternaPopupModal');
      const $ = window.jQuery;
      if ($ && dom && $.fn.modal) {
        const $el = $(dom);
        $el.modal({ backdrop: true, keyboard: true, show: true });
        $el.off('hidden.bs.modal.campanhaInterna').one('hidden.bs.modal.campanhaInterna', () => this.onDismiss());
      } else if (dom) {
        dom.classList.add('show');
        dom.style.display = 'block';
        document.body.classList.add('modal-open');
      }
    },
    closeModal() {
      const dom = document.getElementById('campanhaInternaPopupModal');
      const $ = window.jQuery;
      if ($ && dom && $.fn.modal) {
        $(dom).modal('hide');
      } else if (dom) {
        dom.classList.remove('show');
        dom.style.display = 'none';
        document.body.classList.remove('modal-open');
        this.onDismiss();
      }
    },
    async onDismiss() {
      const id = this.campanhaId;
      this.payload = null;
      this.campanhaId = null;
      if (!id) return;
      try {
        const base = (window.baseUrl || '').replace(/\/$/, '');
        await axios.post(
          `${base}/painel/campanha-internas/popup/dismiss`,
          { campanha_interna_id: id },
          { headers: jsonHeaders }
        );
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
